import React from 'react';
import * as actions from '../Actions';
import ShareOptions from '../ShareOptions';


export default function ({feedItem, eleRef}) {
  // //console.log("feedItem ",feedItem)
    return (
<section className="main_container_block_feeds memoryBlock popular"> 
<div className="main_block_container_feed">
  <div className="block_container_feed_heading_text R15_61" role='heading' tabIndex={0} aria-label={feedItem.title}>
  {feedItem.title?feedItem.title:''}
  </div>

  <div className="content-div-box-artical spacial_Milestone_desktop">
  <div className="heading_baby_name_qna paddingBlock"><div className="baby_name_qna_text">
    <div className="baby_name_qna_profile">
      <img src={feedItem.data[0].userPic?feedItem.data[0].userPic:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png"} onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png"}} alt={`${feedItem.data[0].userName?feedItem.data[0].userName:''}-${feedItem.data[0].userDesc?feedItem.data[0].userDesc:''}`} title={feedItem.data[0].userName?feedItem.data[0].userName:''}/>
      </div>
      <div className="baby_name_qna_profile_content"><div className="M16_21" role="text" tabIndex={0} aria-label={`Added a new memory by ${feedItem.data[0].userName?feedItem.data[0].userName:''}`}> {feedItem.data[0].userName?feedItem.data[0].userName:''} </div><div className="R14_61"> {feedItem.data[0].userDesc?feedItem.data[0].userDesc:''} </div></div></div><div className="memory_ago_text R14_61"> {feedItem.data[0].postDateTime?feedItem.data[0].postDateTime:''}</div></div>

    <div className="topDiscription paddingBlock R16_42" role="textbox" tabIndex={0} aria-label={`Memory caption: ${feedItem.data[0].memoryCaption?feedItem.data[0].memoryCaption:''}`}>
    {feedItem.data[0].memoryCaption?feedItem.data[0].memoryCaption:''}
    </div>
    <div className="content-div_view_artical">
      <img
        src={feedItem.data[0].memoryImage?feedItem.data[0].memoryImage:''} 
        onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"}}
        alt={`${feedItem.data[0].memoryCaption?feedItem.data[0].memoryCaption:''}`} title={feedItem.data[0].memoryCaption?feedItem.data[0].memoryCaption:''}
      />
    </div>
    <div className="profile_comments_view">
    <div className="checkMemBottom"> 
        <div className="post-options flexJustfy">
        <div>
          <div
            className={`icon left likesIcon questin-sizeview ${(feedItem.data[0].isLiked?'active':'')}`}            
          >
            <span className="icon left likesIcon" data-icon-font="" onClick={(e) => actions.likePost(feedItem.data[0].memoryId, feedItem.data[0].isLiked ? 0 : 1, 0, '', '', eleRef,e,feedItem.data[0].likeCount)} role="button" tabIndex={0} aria-label="Like this memory" onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault(); // prevent scrolling when pressing Space
                actions.likePost(feedItem.data[0].memoryId, feedItem.data[0].isLiked ? 0 : 1, 0, '', '', eleRef,e,feedItem.data[0].likeCount);
              }
            }}></span>
            <span className="icons-text R14_61">              
              Like
            </span>
          </div>
           <div
             className="icon left  questin-sizeview">
             <span className='icon left' data-icon-font="e" onClick={() => actions.openCommentPopup(feedItem.data[0].memoryId, "comment", '', eleRef)} role="button" tabIndex={0} aria-label='Comment on this memory' data-popup={`memory${feedItem.data[0].memoryId}`} onKeyDown={(e) => {
               if (e.key === "Enter" || e.key === " ") {
                 e.preventDefault(); // prevent scrolling when pressing Space
                 actions.openCommentPopup(feedItem.data[0].memoryId, "comment", '', eleRef);
                 setTimeout(() => {
                  const popup = document.querySelector('.addPost-popup [tabindex]');
                  if (popup) popup.focus();
                }, 0);
               }
             }}></span>
             <span className="icons-text R14_61">
               Comment
             </span>
           </div>

          </div>

          <div className="socialShare right" id={`share_${feedItem.data[0].memoryId}`}>
            <div className="icon left facebookicons" data-icon-font="J"></div>
              <div className="icon left whatsapp-icons" data-icon-font=""> 
                <span className="icons-text R14_61 cursor-pointer gtm-share" onClick={() => actions.shareOn(feedItem.data[0].memoryId)} role='button' tabIndex={0} aria-label="Share this memory" onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault(); // prevent scrolling when pressing Space
                    actions.shareOn(feedItem.data[0].memoryId);
                  }
                }}> Share </span>

              <ShareOptions feedItem={feedItem} eleRef={this} />
              </div>
              {/* <span data-icon-font="" class="M14_61 icon report-link report-linkfont"></span>
              <div className='share_abuse_cont right' onClick={(e)=>actions.saveAbuseAction(feedItem.data[0].memoryId,feedItem.data[0].isAbuse,eleRef)}><span className={feedItem.data[0].isAbuse && feedItem.data[0].isAbuse != 'false'?"icons-text_qa R15_61 is-active":"icons-text_qa R15_61"} >{feedItem.data[0].isAbuse && feedItem.data[0].isAbuse!= 'false'?"Reported Abuse":"Report Abuse"}</span></div> */}
              </div>
        </div>
      </div>
      <div className="bottom_line_divider_feed"> </div>
      <div className="commentSection">
        <div className="likeComment_counter">
          <div className={`likes R15_61 like_${feedItem.data[0].memoryId}`} id={`like_${feedItem.data[0].memoryId}`} onClick={() => actions.likeUserList(feedItem.data[0].memoryId, 0, '', '', eleRef)}>
          {feedItem.data[0].likeCount?feedItem.data[0].likeCount:'0'} <span className=''>Likes</span>
          </div>
          <div className="comment R15_61">
            {feedItem.data[0].commentCount?feedItem.data[0].commentCount:'0'} Comment
          </div> 
        </div>
        <div className="commentView M15_42">
         {feedItem.data[0].comments && feedItem.data[0].comments.map((comment, index) =>
          <div>
          <strong key={index} className="B15_42">{comment.userName?comment.userName:''}</strong> {comment.comment?comment.comment:''}
          </div>
         )
        }
        </div>
      </div>
    </div>
  </div>
</div>
</section>)}
